import { z } from 'zod'
import type { SortKeyOrFunction } from '../../domain-types/src/utils/sorting/sort-key-or-function.ts'
import type { InferOverride } from './infer-override.ts'

export const PagingOptionsSchema = z.object({
  pageSize: z.number().positive().optional(),
  currentPage: z.number().positive().optional(),
  sortBy: z
    .union([
      z.string(),
      z.function().args(z.any(), z.any()).returns(z.number()),
    ])
    .optional(),
  sortDirection: z.enum(['asc', 'desc']).optional(),
})

export type PagingOptions<T> = InferOverride<
  typeof PagingOptionsSchema,
  {
    sortBy?: SortKeyOrFunction<T>
  }
>
